import { colors } from "./colors";

export const labels1 = [];
export const labels2 = [];

export const options = {
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: {
      display: false,
    },
  },
};

export const defaultData1 = {
  labels: labels1,
  datasets: [
    {
      label: "",
      data: [],
      backgroundColor: colors,
      borderColor: colors,
    },
  ],
};

export const defaultData2 = {
  labels: labels2,
  datasets: [
    {
      label: "",
      data: [],
      backgroundColor: colors,
      borderColor: colors,
    },
  ],
};
